import { Box, Text } from "wealthmode-frontend/gluestack/ui"

import { OverrideField } from "@/components/controls/OverrideField"
import { hexColor, normalizeHexInput } from "@/lib/color"

/**
 * ColorField edits the brand color with a swatch of whatever is currently in
 * the field, sized to match the logo preview above it so the two read as one
 * pair. The swatch follows every keystroke, so a half typed value simply shows
 * nothing rather than a stale color.
 */
export function ColorField({
  value,
  inherited,
  onChange,
}: {
  value: string | null
  inherited: string | null
  onChange: (value: string | null) => void
}) {
  const color = hexColor(value !== null ? value : inherited)

  return (
    <OverrideField
      label="Color"
      value={value}
      inherited={inherited}
      placeholder="RRGGBB"
      // The API stores bare hex digits, so a pasted "#RRGGBB" is trimmed down
      // rather than left to fail validation on save.
      onChange={(next) => onChange(next === null ? null : normalizeHexInput(next))}
      preview={
        <Box
          className="h-24 w-24 items-center justify-center border border-border-medium"
          style={color ? { backgroundColor: color } : undefined}
        >
          {color ? null : <Text className="text-xs text-foreground-secondary">None</Text>}
        </Box>
      }
    />
  )
}
